import { Link } from "gatsby"
import React from "react"

const Fotter = () => (
  <footer class="footer">
      <div class="container">
          <div class="columns">
              <div class="column is-3">
                  <div class="content has-text-centered">
                  <p><Link to="/profile">Profile</Link></p>
              </div>
              </div>
              <div class="column is-3">
                  <div class="content has-text-centered">
                  <p><Link to="/books">おすすめ書籍一覧</Link></p>
                  </div>
              </div>
              <div class="column is-3">
                  <div class="content has-text-centered">
                  <p>お問い合わせ</p>
                  </div>
              </div>
              <div class="column is-3">
                  <div class="content has-text-centered">
                  <p><Link to="/privacy">プライバシーポリシー</Link></p>
                  </div>
              </div>
          </div>
          <div class="columns">
          <div class="column is-12">
                  <div class="content has-text-centered">
                  <p>©Copyright Marsa</p>
                  </div>
          </div>
          </div>
      </div>
  </footer>
)

export default Fotter
